<template>
  <span>
    <span v-if="wait">
      <Loading class="waiting" />
    </span>
    <span v-else>
      <div class="grid">
      <div :class="['leftCol', gdi]">
        <!-- LATERAL -->
        <div class="Row1 unid">
          <span>{{ unit }}</span>
        </div>
        <div :class="['Row2', 'row-period', gdi]">
          <p>{{ $t('dia') }}</p>
          <label>{{ objectList.date }}</label>
        </div>

        <div class="Row3 row-period">
          <p>{{ $t('mes') }}</p>
          <label>{{ objectList.month }}</label>
        </div>

        <div class="Row4 row-period">
          <p>{{ $t('safra') }}</p>
          <span class="days-harvest">
            <label>{{ Math.trunc(objectList.harvestDaysElapsed) }} / {{ Math.trunc(objectList.harvestDaysTotal) }}</label>
            <label class="label-menor">{{ $t('dias') }}</label>
          </span>
        </div>
        <!-- / LATERAL -->
      </div>

      <div class="rightCol">
        <div v-for="item in objectList.onlineStructures" :key="item.id" :class="['colItem', gdi]">
        
          <!-- CABEÇALHO -->
          <div class="Row1">
            <div class="row1Part1">{{ item.productName }}</div>
            <div class="row1Part2">{{ item.unitOfMeasurement }}</div>
          </div>
          <!-- /CABEÇALHO -->

          <!-- METAS DIA -->
          <div v-if="item.type != 0" class="Row2 mainDailyData">
            <!-- / PGDI TYPE = 1 -->
            <div class="text-center">
              <label>
                {{ item.type == 1 && item.dailyData.showRhythm ?  $t('projecao-0') : $t('meta-on-line') }}
              </label>
            </div>

            <div class="row2Part1">
              <label>
                {{
                  item.type == 1 && item.dailyData.showRhythm
                    ? numberFormat(item.dailyData.realProjection)
                    : numberFormat(item.dailyData.simulatedProjection)
                }} ton
              </label>

              <div v-if="item.type == 1" class="row2Part2Type1">
                <div class="defaultTxt">
                  <label v-if="item.type == 1 && item.dailyData.showRhythm">{{ $t('realizado') }}</label>
                  <label v-if="item.type == 1 && item.dailyData.showRhythm" right>
                    {{ numberFormat(item.dailyData.accomplished) }} {{ $t('ton') }}
                  </label>
                </div>
                <label v-if="item.dailyData.showRhythm" >{{ $t('ritmo-para-meta-mensal') }}</label>
                <p v-if="item.dailyData.showRhythm">{{  item.dailyData.idealPace > 0 || item.dailyData.idealPace == -9999 ? 
                                                        numberFormat(item.dailyData.idealPace) +  $t('ton-h') :
                                                        "Meta alcançada!" }} </p>

                <div>
                  <div v-if="item.type == 1 && !item.dailyData.showRhythm && item.dailyData.showProjection" class="dataTextProgress">
                    <div class="defaultTxt">
                      <label >{{ $t('projecao') }}</label>
                      <label right>{{ `${ numberFormat(item.dailyData.percentualProjection)} %` }}</label>
                    </div>

                    <div class="meter green bargraph">
                      <span
                        :style="
                          `width:${
                            item.dailyData.percentualProjection >= 0
                              ? item.dailyData.percentualProjection
                              : 0
                          }%`">
                      </span>
                    </div>

                    <label>{{ numberFormat(item.dailyData.realProjection) }} {{ $t('ton') }}</label>
                  </div>
                  
                </div>
              </div>
            </div>
            <div v-if="item.type == 1 && (item.dailyData.showRhythm || item.dailyData.showProjection)"  class="row1-bottom">
              <label>{{ item.type == 1 && item.dailyData.showRhythm ? $t('ritmo-atual') : $t('realizado') }}</label>
              <label right>
                {{
                  item.type == 1 && item.dailyData.showRhythm
                    ? numberFormat(item.dailyData.currentPace)
                    : numberFormat(item.dailyData.accomplished)
                }} 
                {{
                  item.type == 1 && item.dailyData.showRhythm
                    ? "ton/h"
                    : "ton"
                }}

              </label>
            </div>
            <div v-else-if="item.type == 1 && !item.dailyData.showRhythm && !item.dailyData.showProjection" class="row-gdi">
              <label>{{$t('realizado')}}</label>
              <label right>
                {{ numberFormat(item.dailyData.accomplished) }}
              </label>
            </div>
          </div>
          <!-- / PGDI -->

          <div v-else>
            <div class="row-gdi">
              <label>{{$t('realizado')}}</label>
              <label id="label-realizado-dia" right>
                {{ numberFormat(item.dailyData.accomplished) }}
              </label>
            </div>

          </div>
          <!-- /METAS DIA -->

          <!-- METAS MÊS / SAFRA-->
          <div v-for="(monthAndHasvest, i) in item.monthAndHasvest" :key="i" class="Row3 halfApply">
            <div class="dataTextProgress">
              <div class="defaultTxt">
                <label >{{$t('realizado')}}</label>
                <label rigt v-if="((numberFormat(monthAndHasvest.goal) == '0,00' || numberFormat(monthAndHasvest.goal) == '-0,00')) || 
                (numberFormat(monthAndHasvest.accomplished) == '-9.999,0')">
                      - 
                </label>
                <label right v-if="(numberFormat(monthAndHasvest.goal) != '0,00' && numberFormat(monthAndHasvest.goal) != '-0,00') && (numberFormat(monthAndHasvest.accomplished) != '-9.999,0')">{{ numberFormat(monthAndHasvest.percentualAccomplished) + " %" }}</label>
              </div>

              <div :class="['meter', monthAndHasvest.statusColor]">
                <span
                  class="bargraph"
                  :style="
                    `width:${
                      monthAndHasvest.percentualAccomplished != 0 ? monthAndHasvest.percentualAccomplished : 0
                    }%`
                  "
                >
                </span>
              </div>

              <div class="defaultTxt">
                <label class="mt-2">{{ $t('aderencia') }}</label>
                <label rigt v-if="((numberFormat(monthAndHasvest.relativeGoal) == '0,00' || numberFormat(monthAndHasvest.relativeGoal) == '-0,00')) || 
                (numberFormat(monthAndHasvest.accomplished) == '-9.999,0')">
                      - 
                </label>
                <label right v-if="((numberFormat(monthAndHasvest.relativeGoal) != '0,00' && numberFormat(monthAndHasvest.relativeGoal) != '-0,00')) && 
                (numberFormat(monthAndHasvest.accomplished) != '-9.999,0')">{{ numberFormat(monthAndHasvest.adherence) + " %" }}</label>
              </div>
            </div>
            <div class="dataTextDefault">
              
              <div class="data-goals">
                <label>{{ $t('meta-0') }}</label>
                <label right>{{ numberFormat(monthAndHasvest.goal) }}</label>
              </div>
              
              <div class="data-goals">
                <label>{{ $t('meta-relativa') }}</label>
                <label right>{{ numberFormat(monthAndHasvest.relativeGoal) }}</label>
              </div>
              
              <div class="data-goals">
                <label>{{$t('realizado')}}</label>
                <label id="label-realizado-messafra" class="realValue" right>
                  {{ numberFormat(monthAndHasvest.accomplished) }}
                </label>
              </div>
            
              <div class="data-goals">
                <label>
                  {{
                    monthAndHasvest.status > 0 ?
                    $t('superou-em') :
                    $t('falta')
                  }}
                </label>
                <label class="realValue" right>{{ numberFormat(Math.abs(monthAndHasvest.status)) }}</label>
              </div>

            </div>
          </div>
          <!-- / METAS MÊS / SAFRA-->
        </div>
      </div>
      </div>
    </span>
    <span v-if="timeUpdated.date" class="day-update">{{ $t('atualizacao') }} {{ timeUpdated.date }}</span>
  </span>
</template>

<script>
import axios from "axios";
import { urlMainAPI, defaultSuccess } from "@/global";
import { NumberFormat } from "@/components/flowchart/utils/tools.js"
import Loading from '@/components/template/Loading.vue';
import * as moment from "moment";


const ProductionMonitoring = {
  action: function (callback, timeUpdated) {
    if(!this.stop)
    setTimeout( async function (){
      await callback();
      timeUpdated.date = moment(Date()).format("HH:mm:ss")
      console.log("Dados atualizados.", timeUpdated.date)
    }, 60000)
  },
  stop: false
};

export default {
  name: "ProductionMonitoring",
 
    components: { Loading },

    data() {
    return {
      user: null,
      wait: true,
      gdi: false,
      unit: this.$route.params.unit,
      objectList: [], 
      timeUpdated: {
        date: ""
      }
    };
  },

  methods: {
    numberFormat (num){
      let stNum = NumberFormat(num)
      return stNum.slice(0, stNum.indexOf(",") + 3)
    },
    
    async loadCardsOfProductionMontioring(){
      let role = this.user.role
      let unitId = this.user.UnitId
      const url = `${urlMainAPI}/getproductionmonitoring/${unitId}/${role}`;
      await axios.get(url)
        .then((res) => {
          this.objectList = res.data;
          console.log('res.data :>> ', res.data);
          this.gdi = this.objectList.system == 'G' ? 'gdi' : '';
          this.wait = false;
          this.setStopAnime();
          ProductionMonitoring.action(this.loadCardsOfProductionMontioring, this.timeUpdated)
          this.timeUpdated.date = moment(Date()).format("HH:mm:ss")
        }).catch();
    },
    
    setUser(){
      if(localStorage.userKey){
        this.user = JSON.parse(localStorage.userKey);
      }
    },

    setStopAnime() {
      setTimeout(() => {
        document.querySelectorAll('.meter>span').forEach(c => {
          c.classList.remove('bargraph')
        }) 
      }, 6000)
    }
  },

  async mounted() {
    defaultSuccess(this.$t('carregando-dados-do-metas-online'));
    ProductionMonitoring.stop = false;
    await this.setUser();
    await this.loadCardsOfProductionMontioring();
     defaultSuccess(this.$t('dados-carregados'));
  },

  beforeDestroy(){
    ProductionMonitoring.stop = true;
  }
};
</script>

<style src="./ProductionMonitoring.css" scoped></style>
